import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './salesMeetingLinkQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type SalesMeetingLinkQuery_Query = {
  __typename?: 'Query',
  salesMeetingLink?: string | null
};


export type SalesMeetingLinkQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SalesMeetingLinkQuery = SalesMeetingLinkQuery_Query;


export const SalesMeetingLinkQueryDocument = /*#__PURE__*/ document as unknown as DocumentNode<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>;


/**
 * __useSalesMeetingLinkQuery__
 *
 * To run a query within a React component, call `useSalesMeetingLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesMeetingLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesMeetingLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesMeetingLinkQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>(SalesMeetingLinkQueryDocument, options);
      }
export function useSalesMeetingLinkQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>(SalesMeetingLinkQueryDocument, options);
        }
// @ts-ignore
export function useSalesMeetingLinkQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>;
export function useSalesMeetingLinkQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SalesMeetingLinkQuery | undefined, SalesMeetingLinkQueryVariables>;
export function useSalesMeetingLinkQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>(SalesMeetingLinkQueryDocument, options);
        }
export type SalesMeetingLinkQueryHookResult = ReturnType<typeof useSalesMeetingLinkQuery>;
export type SalesMeetingLinkQueryLazyQueryHookResult = ReturnType<typeof useSalesMeetingLinkQueryLazyQuery>;
export type SalesMeetingLinkQuerySuspenseQueryHookResult = ReturnType<typeof useSalesMeetingLinkQuerySuspenseQuery>;
export type SalesMeetingLinkQueryQueryResult = ApolloReactCommon.QueryResult<SalesMeetingLinkQuery, SalesMeetingLinkQueryVariables>;